import Breadcrumb from "react-bootstrap/Breadcrumb";
import { useNavigate, useResolvedPath } from "react-router-dom";

const BreadcrumbTwo = (props) => {
    const navigate = useNavigate();
    const resolved = useResolvedPath("/backend");
    const resolved2 = useResolvedPath(`/backend/${props.type}`);

    return (
        <Breadcrumb>
            <Breadcrumb.Item
                href={resolved.pathname}
                onClick={(e) => {
                    e.preventDefault();
                    navigate("/backend");
                }}
            >
                หน้าหลัก
            </Breadcrumb.Item>
            <Breadcrumb.Item
                href={resolved2.pathname}
                onClick={(e) => {
                    e.preventDefault();
                    navigate(`/backend/${props.type}`);
                }}
            >
                {props?.names?.[0]}
            </Breadcrumb.Item>
            <Breadcrumb.Item active>{props?.names?.[1]}</Breadcrumb.Item>
        </Breadcrumb>
    );
};

export default BreadcrumbTwo;
